import { useMutation, useQueryClient } from "react-query";

import { httpService } from "utils";
import { DateObject } from "utils/DateObject";

import { useGetAuthorizationStore } from "./useGetAuthorizationStore";
import { ILoggedUser } from "../../user/application/types/ILoggedUser";
import { ILoggedUserDto } from "../../user/application/types/ILoggedUserDto";
import { getUserKey } from "../../user/infrastructure/useGetUser";
import { createChannel } from "../../../utils/hooks/createChannel";
import { UserAction } from "../application/types/UserAction";

export const useLoginUser = () => {
  const channel = createChannel("USER_ACTION");

  const { setAuthorization } = useGetAuthorizationStore((state) => ({
    setAuthorization: state.setAuthorization,
  }));
  const queryClient = useQueryClient();
  return useMutation((data: FormData) => {
    return loginUser(data).then(async (res) => {
      setAuthorization(res.id, res.token);
      await channel.postMessage(UserAction.Login);
      await channel.close()
      await queryClient.invalidateQueries(getUserKey(res.id, res.token));
    });
  });
};

const loginUser = (formData: FormData): Promise<ILoggedUser> => {
  return httpService()
    .post<ILoggedUserDto>(`/e-reservation/log-in`, formData)
    .then((res) => {
      return {
        ...res,
        loginDate: DateObject(res.loginDate),
      };
    });
};
